<template>
  <div>
    <back-btn />
    <v-container fluid>
      <v-row>
        <v-col cols="12" style="overflow: auto">
          <v-card class="card--shadow">
            <vlu-list :volunteers="volunteers" />
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import VluList from "@/components/volunteer/VluList";

import { mapState } from "vuex";
import BackBtn from "@/components/navigation/BackBtn.vue";

export default {
  components: {
    VluList,
    BackBtn,
  },
  computed: {
    ...mapState("Volunteer", ["volunteers"]),
  },
  created() {
    this.$store.dispatch(
      "Volunteer/getVolunteerByTwnId",
      this.$route.params.township_id
    );
  },
};
</script>

<style scoped>
.card--shadow {
  box-shadow: var(--primary-box-shadow) !important;
}
</style>
